import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import FormErrors from '../../components/FormErrors/FormErrors';

class PageContact extends Component {

    constructor (props) {
        super(props);
        this.state = {
            first_name: '',
            last_name: '',
            company_name: '',
            phone: '',
            email: '',
            message: '',
            formErrors: {first_name: '', last_name: '', company_name: '', phone: '',  email: '', message: ''},
            firstNameValid: false,
            lastNameValid: false,
            companyNameValid: false,
            phoneValid: false,
            emailValid: false,
            messageValid: false,
            formValid: false,
        }
      }

    handleUserInput (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({[name]: value},
            () => {this.validateField(name, value)});
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let firstNameValid = this.state.firstNameValid;
        let lastNameValid = this.state.lastNameValid;
        let companyNameValid = this.state.companyNameValid;
        let phoneValid = this.state.phoneValid;
        let emailValid = this.state.emailValid;
        let messageValid = this.state.messageValid;
        let formValid = this.state.formValid;

        switch(fieldName) {
            case 'first_name':
                firstNameValid = value.length > 0;
                fieldValidationErrors.first_name = firstNameValid ? "": "first name can't be left blank";
                break;
            case 'last_name':
                lastNameValid = value.length > 0;
                fieldValidationErrors.last_name = lastNameValid ? "": "last name can't be left blank";
                break;
            case 'company_name':
                companyNameValid = value.length > 0;
                fieldValidationErrors.company_name = companyNameValid ? "": "company name can't be left blank";
                break;
            case 'phone':
                phoneValid = value.length > 0;
                fieldValidationErrors.phone = phoneValid ? "": "phone number can't be left blank";
                break;
            case 'e-mail-address':
                // eslint-disable-next-line
                emailValid = value.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);
                fieldValidationErrors.email = emailValid ? "" : "you must enter a valid email address";
                break;
            case 'message':
                messageValid = value.length > 0;
                fieldValidationErrors.message = messageValid ? "": "your message can't be left blank";
                break;
            default:
                break;
        }
        this.setState({formErrors: fieldValidationErrors,
            firstNameValid: firstNameValid,
            lastNameValid: lastNameValid,
            companyNameValid: companyNameValid,
            emailValid: emailValid,
            phoneValid: phoneValid,
            messageValid: messageValid,
            formValid: formValid
        }, this.validateForm);
    }

    validateForm() {
        this.setState({formValid:
            this.state.firstNameValid &&
            this.state.lastNameValid &&
            this.state.companyNameValid &&
            this.state.phoneValid &&
            this.state.emailValid &&
            this.state.messageValid
        });
    }

    errorClass(error) {
        return(error.length === 0 ? '' : 'has-error');
    }

    isInvalid(error) {
        return(error.length === 0 ? 'false' : 'true');
    }

    render() {
        return (
            <Page primaryTitle="Contact" secondaryTitle="" section="">
                <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageContact">
                    <p className="intro">Drop us a line! We appreciate your feedback, suggestions, and, of course, inquiries into SLA services and products!</p>
                    <form action="https://formspree.io/f/mdknojag" method="post" encType="multipart/form-data">
                        <fieldset>
                            <legend>Contact SLA</legend>
                            <p className="required-message">All fields are required</p>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.first_name))}>
                                <label htmlFor="first_name">First Name:</label>
                                <input onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.first_name)} type="text" name="first_name" id="first_name" className="required"/>
                            </div>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.last_name))}>
                                <label htmlFor="last_name">Last Name:</label>
                                <input onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.last_name)} type="text" name="last_name" id="last_name" className="required"/>
                            </div>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.company_name))}>
                                <label htmlFor="company_name">Company:</label>
                                <input onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.company_name)} type="text" name="company_name" id="company_name" className="required"/>
                            </div>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.phone))}>
                                <label htmlFor="phone">Phone:</label>
                                <input onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.phone)} type="text" name="phone" id="phone" className="required"/>
                            </div>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.email))}>
                                <label htmlFor="e-mail-address">Email:</label>
                                <input onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.email)} type="text" name="e-mail-address" id="e-mail-address" className="required email"/>
                            </div>
                            <div className={"form-group " + (this.errorClass(this.state.formErrors.message))}>
                                <label htmlFor="message">Message:</label>
                                <textarea onChange={(event) => this.handleUserInput(event)} onBlur={(event) => this.handleUserInput(event)} aria-invalid={this.isInvalid(this.state.formErrors.message)} name="message" id="message" rows="8" cols="40" className="required"></textarea>
                            </div>
                            <FormErrors formErrors={this.state.formErrors}/>
                            <div className="submit-group">
                                <input type="hidden" name="subject" value="Contact Form Message from the SLA Website"/>
                                <input disabled={!this.state.formValid} className="btn btn-primary" type="submit" value="Send"/>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                    <SideImage page={this.props.page} />
                </aside>
            </Page>
        );
    }
}

export default PageContact;



// WEBPACK FOOTER //
// ./src/pages/PageContact/PageContact.js